import React from "react";
import { Button } from "@/components/ui/button";
import { ArrowRight, Shield, Zap, HeartHandshake } from "lucide-react";
import { motion } from "framer-motion";

export default function Hero() {
  const handleScroll = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background image */}
      <img
        src="https://media.base44.com/images/public/69d14ed5d129627680ef5d0f/bc1a1d5fa_Untitleddesign2.png"
        alt=""
        fetchpriority="high"
        className="absolute inset-0 w-full h-full object-cover"
      />
      {/* Dark overlay so text stays readable */}
      <div className="absolute inset-0 bg-background/75" />
      {/* Subtle gradient on top */}
      <div className="absolute inset-0 bg-gradient-to-b from-background/30 via-transparent to-background/60" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-24 pb-16 sm:pt-32 sm:pb-24">
        <div className="max-w-4xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}>
            
          </motion.div>

          <h1 className="text-3xl font-bold tracking-tight leading-[1.1] sm:text-3xl md:text-4xl lg:text-5xl">

            
            Are you ready to stop worrying about your{" "}
            <span className="relative inline-block">
              <span className="relative z-10">website</span>
              <span className="absolute bottom-1 left-0 right-0 h-3 bg-accent/20 -z-0 rounded" />
            </span>
            ?
          </h1>

          <p
            className="mt-6 sm:mt-8 text-lg sm:text-xl md:text-2xl text-muted-foreground font-light max-w-2xl mx-auto leading-relaxed">
            
            Can't get ahold of your web person? Can't update your site?
          </p>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="mt-4 text-xl sm:text-2xl md:text-3xl font-semibold">
            
            Let us take care of{" "}
            <span className="underline decoration-accent/40 underline-offset-4">your</span>{" "}
            <span className="text-primary">web hosting</span>.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="mt-10 sm:mt-12 flex flex-col sm:flex-row items-center justify-center gap-4">
            
            <Button
              onClick={() => handleScroll("#contact")}
              size="lg"
              className="bg-primary hover:bg-primary/90 text-primary-foreground rounded-full px-8 py-6 text-base font-semibold shadow-lg shadow-primary/20 hover:shadow-xl hover:shadow-primary/25 transition-all">
              
              Let's Talk About This
              <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
            <Button
              onClick={() => handleScroll("#pricing")}
              variant="outline"
              size="lg"
              className="rounded-full px-8 py-6 text-base font-medium border-border/60 hover:bg-[#F49555] hover:text-white hover:border-[#F49555]">
              
              View Pricing
            </Button>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.5 }}
            className="mt-16 sm:mt-20 grid grid-cols-1 sm:grid-cols-3 gap-6 sm:gap-8 max-w-3xl mx-auto">
            
            {[
            { icon: Shield, label: "Secure & Protected", sub: "Nightly backups included" },
            { icon: Zap, label: "Managed Hosting", sub: "We handle everything" },
            { icon: HeartHandshake, label: "20+ Years Experience", sub: "Supporting businesses like yours" }].
            map((item) =>
            <motion.div
              key={item.label}
              whileHover={{ y: -6 }}
              transition={{ type: "spring", stiffness: 300, damping: 20 }}
              className="flex flex-col items-center gap-2 p-6 rounded-2xl bg-card/70 backdrop-blur-sm border border-border/50 shadow-sm hover:shadow-lg hover:border-primary/30 transition-shadow duration-300">
                <div className="w-10 h-10 rounded-xl bg-primary/[0.08] flex items-center justify-center">
                  <item.icon className="w-5 h-5 text-primary" />
                </div>
                <p className="text-base font-semibold">{item.label}</p>
                <p className="text-sm text-muted-foreground text-center">{item.sub}</p>
              </motion.div>
            )}
          </motion.div>
        </div>
      </div>
    </section>);

}